<template>
  <el-table-column
    prop="retailer_price"
    sortable="custom"
    label="Kisker ár"
    show-overflow-tooltip
    min-width="110"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.retailer_price">{{ (scope.row.retailer_price || 0) | currency }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'retailer_price',
  };
</script>
